import { render, staticRenderFns } from "./ClinicPayments.vue?vue&type=template&id=97ddb836"
import script from "./ClinicPayments.vue?vue&type=script&lang=js"
export * from "./ClinicPayments.vue?vue&type=script&lang=js"
import style0 from "./ClinicPayments.vue?vue&type=style&index=0&id=97ddb836&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports